var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('pipeline-start-active',{attrs:{"height":_vm.height,"width":_vm.width}}):(_vm.pass)?_c('pipeline-start-default',{attrs:{"height":_vm.height,"width":_vm.width}}):_c('pipeline-start-inactive',{attrs:{"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }